// Resolve a photo string into a usable <img src>.
// Handles 3 shapes:
//   - base64 dataURL (legacy product/offer photos): returned as-is
//   - absolute http(s) URL (unsplash fallback): returned as-is
//   - object-storage path (new): prefixed with /api/files/, optionally signed with `auth=<token>`
export function photoSrc(p, token = null) {
  if (!p) return null;
  if (typeof p !== 'string') return null;
  if (p.startsWith('data:')) return p;
  if (p.startsWith('http://') || p.startsWith('https://')) return p;
  const base = process.env.REACT_APP_BACKEND_URL;
  return token
    ? `${base}/api/files/${p}?auth=${token}`
    : `${base}/api/files/${p}`;
}
